import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-primary-light to-primary-lightest">
      <div className="text-center max-w-md mx-auto px-6">
        <div className="glass-card p-8">
          <div className="mb-8">
            <h1 className="text-6xl font-bold text-primary-deep mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-primary-deep mb-4">
              Seite nicht gefunden
            </h2>
            <p className="text-lg text-primary-main mb-6">
              Die von Ihnen gesuchte Seite existiert leider nicht. Möglicherweise wurde sie verschoben oder gelöscht.
            </p>
          </div>
          
          <div className="space-y-4">
            <Button 
              asChild 
              className="w-full bg-primary-main hover:bg-primary-deep text-white font-medium"
            >
              <a href="/">
                <Home className="mr-2 h-5 w-5" />
                Zur Startseite
              </a>
            </Button>
            
            <Button 
              variant="outline" 
              onClick={() => window.history.back()}
              className="w-full border-primary-main text-primary-main hover:bg-primary-main hover:text-white"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Zurück
            </Button>
          </div>
        </div>
        
        <p className="text-primary-deep/70 text-sm mt-6">
          Bei weiteren Fragen kontaktieren Sie uns gerne.
        </p>
      </div>
      
      {/* Decorative elements matching your website style */}
      <div className="absolute top-20 left-20 w-32 h-32 bg-primary-main/20 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-primary-deep/20 rounded-full blur-xl"></div>
    </div>
  );
};

export default NotFound;